import { render, staticRenderFns } from "./AvatarCrud.vue?vue&type=template&id=ad01fe80&scoped=true&"
import script from "./AvatarCrud.vue?vue&type=script&lang=js&"
export * from "./AvatarCrud.vue?vue&type=script&lang=js&"
import style0 from "./AvatarCrud.vue?vue&type=style&index=0&id=ad01fe80&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ad01fe80",
  null
  
)

export default component.exports